import type { paths } from "@/api-schema";
import { useBranchByUuidQuery } from "@/common/api/branch/use-branch-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { BranchUpdateFormFields } from "./_components/update-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/branch/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/branch/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useBranchByUuidQuery}
      notFoundProps={{
        title: t("masterdata:BranchNotFound"),
        message: t("masterdata:BranchDoesNotExist"),
        description: t("masterdata:PleaseCheckBranchIdOrContactSupport"),
        backTo: "~/masterdata/branch",
        backToLabel: t("masterdata:BackToBranchOverview"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Form}
      title={t("masterdata:EditBranch")}
      subTitle={t("common:ReviewAndSaveChangesDescription")}
    >
      <BranchUpdateFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
